<style lang="scss">
  @import '../resources/scss/objectives.scss';
</style>

<script lang="ts">
  import type ObjectiveItem from '../api/rest/directus-cms/about/models/ObjectiveItem'

  export let objective: ObjectiveItem
</script>

<div class="objective-item d-flex flex-column justify-content-between align-items-end">
  <div class="">
    <img src={objective.image?.fullUrl} alt={objective.title} />
  </div>
</div>
